// API client for the platform-side (demo + admin) endpoints.
// The marketing-form client is in `api.js`.

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY_STORAGE = "continuum.adminKey";

// ---------- public demo ----------

export const demoApi = axios.create({
  baseURL: `${API}/demo`,
  headers: { "Content-Type": "application/json" },
});

export async function fetchCommunities() {
  const { data } = await demoApi.get("/communities");
  return data;
}
export async function fetchCommunityBundle(slug) {
  const { data } = await demoApi.get(`/communities/${slug}`);
  return data;
}
export async function fetchMethodVersion() {
  const { data } = await demoApi.get("/method-version");
  return data;
}
export async function fetchTopQuestions(limit = 6) {
  const { data } = await demoApi.get(`/top-questions?limit=${limit}`);
  return data;
}

// ---------- admin ----------

export function getAdminKey() {
  try {
    return sessionStorage.getItem(ADMIN_KEY_STORAGE) || "";
  } catch {
    return "";
  }
}

export function setAdminKey(key) {
  try {
    if (key) sessionStorage.setItem(ADMIN_KEY_STORAGE, key);
    else sessionStorage.removeItem(ADMIN_KEY_STORAGE);
  } catch {
    /* noop */
  }
}

function adminHeaders() {
  return { "X-Admin-Key": getAdminKey(), "Content-Type": "application/json" };
}

export async function verifyAdminKey(key) {
  // Try the key explicitly so it can be tested before being stored.
  const { data } = await axios.post(`${API}/admin/verify-key`, null, {
    headers: { "X-Admin-Key": key },
  });
  return data;
}

export async function fetchAdminSummary() {
  const { data } = await axios.get(`${API}/admin/summary`, { headers: adminHeaders() });
  return data;
}
export async function fetchAdminWaitlist() {
  const { data } = await axios.get(`${API}/admin/waitlist`, { headers: adminHeaders() });
  return data;
}
export async function fetchAdminWalkthrough() {
  const { data } = await axios.get(`${API}/admin/walkthrough`, { headers: adminHeaders() });
  return data;
}
export async function fetchAdminQuestions() {
  const { data } = await axios.get(`${API}/admin/community-question`, { headers: adminHeaders() });
  return data;
}
export async function reseedDemo() {
  const { data } = await axios.post(`${API}/admin/reseed`, null, { headers: adminHeaders() });
  return data;
}
